module.exports = __webpack_public_path__ + "img/result.f0a993ee.png";